import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';

export async function page(payload) {
  return request(`/iwms-wms/wms/pickDistribute/page`, {
    method: 'POST',
    body: payload
  })
}

export async function modifyDistributeQty(payload) {
  return request(`/iwms-wms/wms/pickDistribute/modifyDistributeQty`, {
    method: 'POST',
    body: payload
  })
}

export async function distributeState(payload) {
  return request(`/iwms-wms/wms/pickDistribute/${payload.uuid}/distributeState`, {
    method: 'POST',
  })
}
